import { useEnterpriseSupport } from 'hooks/useEnterpriseSupport'

const bytesPerMegabyte = 1000000
const standardAudienceUploadLimitMegabytes = 10
const enterpriseAudienceUploadLimitMegabytes = 50

export interface AudienceUploadLimit {
  maxFileSize: number
  label: string
}

export const useAudienceUploadLimit = (standardLimitMegabytes: number = standardAudienceUploadLimitMegabytes): AudienceUploadLimit => {
  const isEnterpriseOrganization = useEnterpriseSupport()
  const limitMegabytes = isEnterpriseOrganization ? enterpriseAudienceUploadLimitMegabytes : standardLimitMegabytes

  return { maxFileSize: limitMegabytes * bytesPerMegabyte, label: `${limitMegabytes}MB` }
}
